// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"0e85ea63","433":"3a479e31","520":"9fad3ffe","831":"031b7652","979":"e2a74058","989":"9fad3ffe"}[chunkId] + ".chunk.css";
};